import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FiLoader } from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import { storeInvite } from "../utils/invite";

/**
 * Landing page for invite links: /invite/:code
 *
 * Keeps the code for the sign-up to send, then takes the visitor to sign up. Someone
 * already signed in can't be invited any more, so they just go home.
 */
const InviteLandingPage = ({ isDark = true }) => {
  const { code } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (isAuthenticated) {
      navigate("/", { replace: true });
      return;
    }
    storeInvite(code);
    navigate("/auth", { replace: true });
  }, [code, isAuthenticated, loading, navigate]);

  return (
    <div
      className="flex min-h-screen w-full items-center justify-center bg-bg-base"
    >
      <FiLoader className="h-7 w-7 animate-spin text-accent-text" />
    </div>
  );
};

export default InviteLandingPage;
